import $ from 'jquery';

/**
 * Loads the navbar search bar's chunk once the main thread is free, or immediately if the user
 * reaches for the search box first.
 *
 * autocomplete.js is 229KB parsed and 64KB over the wire - InstantSearch, the Algolia
 * helper and Preact - and the search box is in the navbar, so it was fetched on EVERY page at
 * DOM ready, competing with the resources that decide when the page paints.
 *
 * Deferring it to requestIdleCallback keeps the behaviour identical and the timing better: the
 * bar still initialises on its own a few milliseconds later, with no interaction required, so a
 * user who never searches is unaffected and a user who does finds it ready. The interaction
 * listeners are the safety net for the case idle never comes soon enough - someone who clicks
 * straight into the box on a busy page - and NOT the primary trigger, because InstantSearch
 * takes over the input when it initialises and keystrokes typed before that would be lost.
 *
 * requestIdleCallback is unsupported in Safari before 16.4, hence the timeout fallback.
 */
export function loadSearchBarWhenIdle() {
    const $boxes = $('#searchBox, .js-search-box-mobile');
    if (!$boxes.length) return;

    // The mounts are empty <div>s until InstantSearch fills them, so they collapse to no
    // clickable height. Bind the safety net to the surrounding controls that already have
    // dimensions (#nav-search / .top-navbar-mobile__search) as well as the mounts themselves
    // (which get a min-height in _search.scss matching the populated input).
    const $preload = $boxes.add('#nav-search, .top-navbar-mobile__search');

    let started = false;
    const start = function () {
        if (started) return;
        started = true;
        $preload.off('.searchbar-preload');
        import('./autocomplete.js')
            .then(({ initSearchBar }) => initSearchBar())
            .catch((err) => console.error('[search] failed to load', err));
    };

    $preload.on('focusin.searchbar-preload pointerdown.searchbar-preload', start);

    if (typeof window.requestIdleCallback === 'function') {
        // The timeout is the deadline, not the delay: a page that never goes idle still gets
        // the search bar within 2s rather than never.
        window.requestIdleCallback(start, { timeout: 2000 });
    } else {
        setTimeout(start, 200);
    }
}
